import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown delle citazioni dal Talmud Bavli */
@Component({
  selector: 'app-talmud-bavli-dropdown',
  templateUrl: '../quote-template.html',
  styleUrls: ['../editor-dropdowns.css']
})
export class TalmudBavliDropdownComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input()
  public value: string;
  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**Lista delle possibili citazioni da Talmud Bavli */
  noteList = [
    {
      etichetta: '‘Arakhìn',
      valore: 'TB, <i>‘Arakhìn</i>'
    },
    {
      etichetta: '‘Avodà Zarà',
      valore: 'TB, <i>‘Avodà Zarà</i>'
    },
    {
      etichetta: '‘Eruvìn',
      valore: 'TB, <i>‘Eruvìn</i>'
    },
    {
      etichetta: 'Bavà Batrà',
      valore: 'TB, <i>Bavà Batrà</i>'
    },
    {
      etichetta: 'Bavà Metzi‘à',
      valore: 'TB, <i>Bavà Metzi‘à</i>'
    },
    {
      etichetta: 'Bavà Qammà',
      valore: 'TB, <i>Bavà Qammà</i>'
    },
    {
      etichetta: 'Bekhoròt',
      valore: 'TB, <i>Bekhoròt</i>'
    },
    {
      etichetta: 'Berakhòt',
      valore: 'TB, <i>Berakhòt</i>'
    },
    {
      etichetta: 'Betzà',
      valore: 'TB, <i>Betzà</i>'
    },
    {
      etichetta: 'Chaghigà',
      valore: 'TB, <i>Chaghigà</i>'
    },
    {
      etichetta: 'Chullìn',
      valore: 'TB, <i>Chullìn</i>'
    },
    {
      etichetta: 'Ghittìn',
      valore: 'TB, <i>Ghittìn</i>'
    },
    {
      etichetta: 'Horayòt',
      valore: 'TB, <i>Horayòt</i>'
    },
    {
      etichetta: 'Keritòt',
      valore: 'TB, <i>Keritòt</i>'
    },
    {
      etichetta: 'Ketubbòt',
      valore: 'TB, <i>Ketubbòt</i>'
    },
    {
      etichetta: 'Makkòt',
      valore: 'TB, <i>Makkòt</i>'
    },
    {
      etichetta: 'Me‘ilà',
      valore: 'TB, <i>Me‘ilà</i>'
    },
    {
      etichetta: 'Meghillà',
      valore: 'TB, <i>Meghillà</i>'
    },
    {
      etichetta: 'Menachòt',
      valore: 'TB, <i>Menachòt</i>'
    },
    {
      etichetta: 'Mo‘èd Qatàn',
      valore: 'TB, <i>Mo‘èd Qatàn</i>'
    },
    {
      etichetta: 'Nazìr',
      valore: 'TB, <i>Nazìr</i>'
    },
    {
      etichetta: 'Nedarìm',
      valore: 'TB, <i>Nedarìm</i>'
    },
    {
      etichetta: 'Niddà',
      valore: 'TB, <i>Niddà</i>'
    },
    {
      etichetta: 'Pesachìm',
      valore: 'TB, <i>Pesachìm</i>'
    },
    {
      etichetta: 'Qiddushìn',
      valore: 'TB, <i>Qiddushìn</i>'
    },
    {
      etichetta: 'Rosh haShanà',
      valore: 'TB, <i>Rosh haShanà</i>'
    },
    {
      etichetta: 'Sanhedrìn',
      valore: 'TB, <i>Sanhedrìn</i>'
    },
    {
      etichetta: 'Shabbàt',
      valore: 'TB, <i>Shabbàt</i>'
    },
    {
      etichetta: 'Shevu‘òt',
      valore: 'TB, <i>Shevu‘òt</i>'
    },
    {
      etichetta: 'Sotà',
      valore: 'TB, <i>Sotà</i>'
    },
    {
      etichetta: 'Sukkà',
      valore: 'TB, <i>Sukkà</i>'
    },
    {
      etichetta: 'Ta‘anìt',
      valore: 'TB, <i>Ta‘anìt</i>'
    },
    {
      etichetta: 'Tamìd',
      valore: 'TB, <i>Tamìd</i>'
    },
    {
      etichetta: 'Temurà',
      valore: 'TB, <i>Temurà</i>'
    },
    {
      etichetta: 'Yevamòt',
      valore: 'TB, <i>Yevamòt</i>'
    },
    {
      etichetta: 'Yomà',
      valore: 'TB, <i>Yomà</i>'
    },
    {
      etichetta: 'Zevachìm',
      valore: 'TB, <i>Zevachìm</i>'
    }
  ]; 

  /**Indice elemento selezionato */
  public selected = 0;

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.valueChange.emit(value);
  }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext() {
    this.selected++;
    if (this.selected >= this.noteList.length) {
      this.selected = this.noteList.length - 1;
    }
  };
  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious() {
    this.selected--;
    if (this.selected < 0) {
      this.selected = 0;
    }
  };
  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection() {
    this.changeValue(this.noteList[this.selected]);
  };
  constructor() { }

}
